/**
* Testimonials JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonials' ).length ) {
        $( '.testimonials' ).each( function( index, element ) {
          new Splide( element, {
            type: 'fade',
            perPage: 1,
            perMove: 1,
            rewind: true,
            arrows: true,
            pagination: false,
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials', COMPONENT );
} )( app );
